import { NgModule } from '@angular/core';
import { HowInstallComponent } from '@app/shared/modals/jfse/how-install/how-install.component';
import { SafePipe } from '@app/shared/pipes/safe.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { IconModule } from '@ui/icon';
import { JfseIframeModalComponent } from '@app/shared/modals/jfse/jfse-iframe-modal/jfse-iframe-modal.component';
import { LoadingButtonModule } from '@ui/loading-button/loading-button.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ShowInclusionTypePipe } from '@app/shared/pipes/showInclusionType.pipe';
import { JfseVitalSyncComponent } from './components/jfse/jfse-vital-sync/jfse-vital-sync.component';
import { FormatDateToUtcDirective } from './directives/format-date-to-utc.directive';
import { DisableForNonAdminDirective } from './directives/disabledForNonAdmin.directive';
import { TranslateAlertPipe } from '@app/shared/pipes/translateAlert.pipe';
import { FirstWordTitlecasePipe } from '@app/shared/pipes/first-word-titlecase.pipe';
import { TruncatePipe } from '@app/shared/pipes/truncate.pipe';
import { TabletOptionComponent } from '@app/shared/components/tablet-option/tablet-option.component';
import { CheckboxModule } from '@ui/checkbox';
import { RadioModule } from '@ui/radio';
import { ShippingAddressComponent } from '@app/shared/components/shipping-address/shipping-address.component';
import { ButtonSelectorModule } from '@ui/button-selector';

@NgModule({
    declarations: [
        HowInstallComponent,
        JfseIframeModalComponent,
        SafePipe,
        JfseVitalSyncComponent,
        FormatDateToUtcDirective,
        ShowInclusionTypePipe,
        DisableForNonAdminDirective,
        TranslateAlertPipe,
        FirstWordTitlecasePipe,
        TruncatePipe,
        TabletOptionComponent,
        ShippingAddressComponent,
    ],
    exports: [
        HowInstallComponent,
        JfseIframeModalComponent,
        SafePipe,
        JfseVitalSyncComponent,
        FormatDateToUtcDirective,
        ShowInclusionTypePipe,
        DisableForNonAdminDirective,
        TranslateAlertPipe,
        FirstWordTitlecasePipe,
        TruncatePipe,
        TabletOptionComponent,
        ShippingAddressComponent,
        CheckboxModule,
        RadioModule,
        ButtonSelectorModule,
    ],
    imports: [TranslateModule, IconModule, LoadingButtonModule, CommonModule, FormsModule, ReactiveFormsModule, CheckboxModule, RadioModule, ButtonSelectorModule],
})
export class SharedModule {}
